import axios from 'axios';

const apiUrl = 'https://admin.djinnapps.com/api/V1';

export const getUserGuideGroupsList = async (appToken: string) => {
  try {
    const { data } = await axios.get(`${apiUrl}/user-guide-groups`, {
      headers: {
        Token: appToken,
      },
    });
    return data;
  } catch (error) {
    return [];
  }
};

export const getUserGuides = async (appToken: string, search?: string) => {
  try {
    const {
      data: { data },
    } = await axios.get(`${apiUrl}/guides`, {
      params: {
        search,
        page: 1,
        perPage: 1000,
      },
      headers: {
        Token: appToken,
      },
    });
    return data;
  } catch (error) {
    return [];
  }
};

export const getUserGuide = async (appToken: string, slug: string) => {
  try {
    const { data } = await axios.get(`${apiUrl}/guides/${slug}`, {
      headers: {
        Token: appToken,
      },
    });
    return data;
  } catch (error) {
    return null;
  }
};

export const submitSupportQuery = async (
  appToken: string,
  formData: {
    name: string;
    email: string;
    content: string;
  }
) => {
  try {
    const { data } = await axios.post(
      `${apiUrl}/support`,
      { ...formData, type: 'technical', submittedBy: 'HelperAttachment' },
      {
        headers: {
          Token: appToken,
        },
      }
    );
    return data;
  } catch (error) {
    return [];
  }
};
